export default "__VITE_ASSET__DzD5VRpW__"